<template lang="html">
  <div class="alerts">
    <div class="alerts-container">
      <transition-group name="alert">
        <div
          class="alert flex flex-row items-center"
          v-for="alert in alerts"
          :key="alert.id">
          <img
            class="alert-icon"
            :src="require('../assets/' + alert.state + '.png')">
          <p class="alert-text pr-20">{{ alert.text }}</p>
          <!-- <span class="close" v-on:click="close(alert)"></span> -->
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

export default {
  name: 'Alerts',
  mixins: [eventHubMixin],
  props: {
    alerts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    // this.eventHub.$on('alert:add', (details) => {
    //   this.create(details);
    // });
  },

  methods: {
    // close(id) {
    //   this.$emit("close-alert", id)
    // },
    // create(details) {
    //   this.alerts.push(details);
    // }
  },
};
</script>
